// iOS Safari ignores `user-scalable=no`; block its pinch gestures explicitly.
// Double-tap zoom is disabled by `touch-action` in styles.css.
export function lockViewportZoom(doc: Document = document) {
  const prevent = (event: Event) => event.preventDefault();
  for (const type of ['gesturestart', 'gesturechange', 'gestureend']) doc.addEventListener(type, prevent, { passive: false });
  doc.addEventListener('touchmove', (event) => { if (event.touches.length > 1) event.preventDefault(); }, { passive: false });
}
